import { Box, Button, Grid, IconButton, Stack, Typography } from "@mui/material";
import { VerificationBannerStyles } from "./styles/VerficationBannerStyles";
import { Close } from "@mui/icons-material";
import CnBLadySVG from "src/icons/CnBLadySVG";
import { useHistory } from "react-router-dom";

interface VerificationBannerBoxProps {
  onClose?: () => void;
  message?: string;
  hideHeader: boolean;
  buttonTitle: string;
  subTitle: string;
  subTitleFontSize: string;
  messageFontSize: string;
  iconHeight: string;
  iconWidth: string;
  boxHeight: string;
  boxWidth: string;
}

export function VerificationBannerBox(props: VerificationBannerBoxProps) {
  const classes = VerificationBannerStyles();
  const history = useHistory();

  const handleClick = () => {
    if (props.onClose) {
      props.onClose();
    }
    history.push("/application");
  };

  return (
    <Box minHeight={props.boxHeight} maxWidth={props.boxWidth}>
      {!props.hideHeader && (
        <Grid
          container
          item
          className={classes.titleGrid}
          justifyContent="space-between"
          alignItems="center">
          <Grid item xs={2}></Grid>
          <Grid item xs={8}>
            <Typography className={classes.title} align="center">
              Verify your account
            </Typography>
          </Grid>
          <Grid item xs={2} textAlign="center">
            <IconButton sx={{ alignSelf: "baseline", color: "#FFFFFF" }} onClick={props.onClose}>
              <Close fontSize="large" />
            </IconButton>
          </Grid>
        </Grid>
      )}

      <Grid item className={classes.innerBox}>
        <CnBLadySVG height={props.iconHeight} width={props.iconWidth} />
      </Grid>
      <Grid item>
        <Stack spacing={1}>
          <Typography fontSize={props.subTitleFontSize} className={classes.messageOne}>
            {props.subTitle}
          </Typography>
          <Typography fontSize={props.messageFontSize} className={classes.messageTwo}>
            {props.message}
          </Typography>
        </Stack>
      </Grid>
      <Grid item>
        <Button
          disableRipple
          sx={{ margin: "24px", height: "43px" }}
          onClick={handleClick}
          className={classes.button}>
          {props.buttonTitle}
        </Button>
      </Grid>
    </Box>
  );
}
